var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8917 31.8283C33.5067 30.3108 34.7933 28.4782 35.6719 26.4437C36.5506 24.4092 37.0026 22.2161 37 20C37 11.025 29.725 3.75 20.75 3.75C11.775 3.75 4.50001 11.025 4.50001 20C4.49745 22.2161 4.94946 24.4092 5.82809 26.4437C6.70673 28.4782 7.99333 30.3108 9.60834 31.8283C12.6199 34.6732 16.6073 36.2556 20.75 36.25C24.8928 36.2556 28.8801 34.6732 31.8917 31.8283ZM10.9917 29.6867C12.1618 28.2227 13.6467 27.0412 15.3361 26.2299C17.0254 25.4185 18.8759 24.9981 20.75 25C22.6241 24.9981 24.4746 25.4185 26.164 26.2299C27.8533 27.0412 29.3382 28.2227 30.5083 29.6867C29.2317 30.9762 27.7118 31.9993 26.0366 32.6969C24.3615 33.3944 22.5646 33.7523 20.75 33.75C18.9355 33.7523 17.1385 33.3944 15.4634 32.6969C13.7883 31.9993 12.2683 30.9762 10.9917 29.6867ZM27 15C27 16.6576 26.3415 18.2473 25.1694 19.4194C23.9973 20.5915 22.4076 21.25 20.75 21.25C19.0924 21.25 17.5027 20.5915 16.3306 19.4194C15.1585 18.2473 14.5 16.6576 14.5 15C14.5 13.3424 15.1585 11.7527 16.3306 10.5806C17.5027 9.40848 19.0924 8.75 20.75 8.75C22.4076 8.75 23.9973 9.40848 25.1694 10.5806C26.3415 11.7527 27 13.3424 27 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.49f31369c00cc40490a2e26711c1d177.svg";
export { ForwardRef as ReactComponent };